export default __webpack_public_path__ + "8d73443d1f2747958d0fd790969cd272.png";